import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Input, Spacer } from "@nextui-org/react";

export default function Form({ data, func, notify }) {
  const [count, setCount] = useState("");
  const [name, setName] = useState("");
  const { register, handleSubmit } = useForm();

  const onSubmit = (d) => {
    if (data.period === "free") {
    } else if (!name || !count) {
      notify("Fill the fields");
      return;
    } else if (count <= data.min) {
      notify("Min Count: " + data.min);
      return;
    }
    d = {
      ...d,
      desc: data.desc,
      price: (data.price * count).toFixed(2),
      wei: data.wei * count,
    };
    console.log(data.desc);
    data.period === "free"
      ? (window.location.href =
          "https://discord.gg/dogehype-842067157608693761")
      : func(d);
    setCount("");
    setName("");
  };

  return (
    <div>
      <div className="w-full max-w-sm bg-gray-950 border border-gray-900 rounded-lg shadow dark:bg-zinc-900 dark:border-neutral-700">
        {/* <img
          className="p-4 rounded-t-lg object-cover max-h-36 w-22 mx-auto"
          src={data.img}
          alt={data.desc}
        /> */}
        <div class={`clip-text ${data.platform.toLowerCase()}`}>{data.platform}</div>
        <div className="px-5 pb-5">
          <h5 className="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">
            {data.titlemain}
          </h5>
          <div className="flex items-center mt-2.5 mb-5"></div>
          <form style={{ width: "100%" }} onSubmit={handleSubmit(onSubmit)}>
            <Input
              size="lg"
              autoComplete="off"
              type="text"
              value={name}
              variant="bordered"
              label={data.title}
              placeholder={data.placeholder}
              fullWidth
              {...register("name", {
                onChange: (e) => setName(e.target.value),
              })}
            />
            <Spacer y={7} />
            {data.period === "free" ? (
              <Input
                size="lg"
                isDisabled
                autoComplete="off"
                type="number"
                variant="bordered"
                label="Quantity"
                placeholder={data.min}
                min={data.min}
                value={20}
                fullWidth
                {...register("count", { value: 20 })}
              />
            ) : (
              <Input
                size="lg"
                autoComplete="off"
                type="number"
                variant="bordered"
                label="Quantity"
                placeholder={data.placeholder2 || data.min}
                min={data.min}
                value={count}
                fullWidth
                {...register("count", {
                  onChange: (e) => setCount(e.target.value),
                })}
              />
            )}
            <Spacer y={7} />
            <div className="flex items-center justify-between">
              <span className="text-3xl font-bold text-gray-900 dark:text-white">
                ${(data.price * count).toFixed(2)}
              </span>
              <button
                type="submit"
                className="text-white bg-green-500 hover:bg-green-400 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-green-500 dark:hover:bg-green-400 dark:focus:ring-green-800"
              >
                Buy Now
              </button>
            </div>
            <Spacer y={5} />
          </form>
        </div>
      </div>
    </div>
  );
}
